import clone from 'lodash/clone';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks';
import { IObject } from 'types';
import { Button } from 'components/ui';
import { Footer } from './menu-footer.styled';

interface IProps {
  flat: boolean;
  closePortal: () => void;
}

export const MenuFooter = observer(({ flat, closePortal }: IProps) => {
  const { fias } = useStore();

  const checkSearchButton = (): boolean => {
    if (
      fias.statuses.fiasTree.pending ||
      (!fias.currentSelectedHouses.length &&
        !fias.confirmedSelectedHouses.length)
    ) {
      return true;
    }

    if (!flat && fias.confirmedSelectedHouses.length) {
      let params: IObject[] = clone(fias.currentSelectedHouses);
      params = params.filter(
        (item: IObject) => !fias.confirmedSelectedHouses.includes(item)
      );

      if (
        !params.length &&
        fias.currentSelectedHouses.length ===
          fias.confirmedSelectedHouses.length
      ) {
        return true;
      }
    }

    return false;
  };

  const applyItems = (): void => {
    fias.setConfirmedSelectedHouses(fias.currentSelectedHouses);
    fias.setConfirmedSelectedFlats(fias.currentSelectedFlats);
    closePortal();
  };

  return (
    <Footer>
      {/*TODO: Раньше тут была кнопка высотой 26px. Новая кнопка бывает 24 или 32, выбрал 32px*/}
      <Button
        size={'s'}
        variant={'outline'}
        disabled={checkSearchButton()}
        onClick={applyItems}
      >
        Применить
      </Button>
    </Footer>
  );
});
